import type { ContextoApp, AppConfigFront } from '@comun/appsConfigs'
import { contextoApp } from '../assets/contextoApp'
import { ref, computed } from 'vue'

export { contextoApp }
export type { ContextoApp, AppConfigFront }

const contextoSegunServidorRef = ref<Partial<AppConfigFront> | undefined>(undefined)

export const contextoSegunServidor = computed(() => contextoSegunServidorRef.value)
export const contextoActualizadoApp = computed(() => {
  const deFabrica: ContextoApp = contextoApp
  const deServidor = contextoSegunServidorRef.value
  if (!deServidor) return deFabrica
  return {
    appConfig: { ...deFabrica.appConfig, ...deServidor },
    buildConfig: deFabrica.buildConfig
  }
})

export function ActualizarAppConfig(ctx: AppConfigFront | undefined) {
  contextoSegunServidorRef.value = ctx
}
